
import { Component, Prop, Vue } from 'vue-property-decorator'
import { FeaturesConfig } from '@mg/web-components/types'
import { FooterProps } from '@mg/web-components/Footer/types'
import Footer from '@mg/web-components/Footer/index'
import { Container } from '@mg/micro/vue2/Container'
import Divider from '@mg/web-components/Atoms/Divider'
import FooterCopyright from '@mg/web-components/Footer/footerCopyright.vue'
import TheScrollTop from '~/components/footer/TheScrollTop.vue'
import { GET_CNC_LINKS } from '~/graphql/gql/cncLinks'
import { Shops } from '~/config/shops'
import {
  GET_CONTENT_BY_TITLE,
  GQLGetContentByTitleQueryInput,
} from '~/graphql/gql/content'
import { GQLCncLink, GQLContent } from '~/graphql/__generated__/interfaces'

@Component({
  apollo: {
    getCncLinks: {
      query: GET_CNC_LINKS,
      skip(): boolean {
        return this.$shopConfig.shopId !== Shops.CZ10MA
      },
    },
    getContentByTitle: {
      query: GET_CONTENT_BY_TITLE,
      update(data: { getContentByTitle: GQLContent }) {
        try {
          if (data.getContentByTitle.body) {
            return JSON.parse(data.getContentByTitle.body)
          }
        } catch (e) {
          this.$logger.error(
            `TheFooterDynamic - getContentByTitle query update - json is not valid : ${e}`,
            e
          )
        }

        return null
      },
      variables: {
        title: 'nxt_footer_basic',
      } as GQLGetContentByTitleQueryInput,
    },
  },
  components: {
    Container,
    Divider,
    Footer,
    FooterCopyright,
    TheScrollTop,
  },
})
export default class TheFooterBasic extends Vue {
  getContentByTitle: FooterProps
  getCncLinks: GQLCncLink[]

  @Prop(String) shopId: string

  @Prop({ required: false, type: Object })
  readonly featuresConfig?: FeaturesConfig

  get items() {
    return this.getContentByTitle
  }
}
